module.exports = __webpack_public_path__ + "img/human.73ea94fe.gif";